import { render, staticRenderFns } from "./assignInstitutionsDialog.vue?vue&type=template&id=fa1ae2de"
import script from "./assignInstitutionsDialog.vue?vue&type=script&lang=ts"
export * from "./assignInstitutionsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports